<template>
    <div class="default-bg">
      <top-navigation></top-navigation>
      <div class="container-fluid" v-if="factCard">
        <div class="row">
          <div class="col-2 pt-5">
            <div class="actions text-center m-1 with-cursor" @click="flipped = !flipped">
              <img src="../../assets/img/flip.png"/>
              <h5 class="m-3">Flip Card</h5>
            </div>
            <div class="actions text-center m-1 with-cursor" v-if="factCard.meta.pdf_file">
              <a :href="factCard.meta.pdf_file" download>
              <img src="../../assets/img/download.png"/>
                <h5 class="m-3">Download Card</h5>
              </a>
            </div>
          </div>
          <div v-if="factCard" class="col-10 fact-card" :class="{ flipped }">
            <div class="fact-card-inner">
            <div class="fact-card-bg front" :style="card(factCard.meta.image_1)">
            </div>
            <div class="fact-card-bg back" :style="card(factCard.meta.image_2)">
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import TopNavigation from '../../components/TopNavigation'
import { mapGetters } from 'vuex'
export default {
  name: 'FactCard',
  components: { TopNavigation },
  props: {
    id: String
  },
  data () {
    return {
      flipped: false
    }
  },
  computed: {
    ...mapGetters(['factCardsList']),
    factCard () {
      return this.factCardsList.filter(factCard => factCard.ID === parseInt(this.id))[0]
    }
  },
  methods: {
    card (img) {
      return { backgroundImage: 'url("' + img + '")' }
    }
  }
}
</script>

<style scoped>
  .fact-card img {
  }

  .actions {
    color: #ffffff;
  }

  .actions img {
    width: 50%;
  }

  .actions h5 {
    font-size: 12pt;
  }

  .fact-card .front {
    text-align: left;
  }

  .fact-card .back {
    text-align: left;
    transform: rotateY(180deg);
  }

  .fact-card .fact-card-inner {
    transform-style: preserve-3d;
    text-align: center;
    transition: transform 0.8s;
    height: 80vh;
    width: 100%;
  }
  .fact-card .front, .fact-card .back {
    position: absolute;
    backface-visibility: hidden;
  }

  .fact-card.flipped .fact-card-inner {
    transform: rotate3d(1, 1, 0, 180deg) scale(0.7);
  }

  .fact-card-bg {
    background-repeat: no-repeat;
    background-position: center;
    height: 100%;
    width: 100%;
    background-size: contain;
  }
  a {
    color: #ffffff;
  }

  a:hover {
    color: #e4e4e4;
  }
</style>
